import { Theme } from 'src/app/theme/theme';

export let theme: Theme;
